import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { fetchRagFiles } from '@/api/content/file'
import { contentSearchSchema } from '@/common/contentSearchSchema'
import { useProjectBreadcrumb } from '@/common/useProjectBreadcrumb'
import { RagFilePage } from '@/components/RagFilePage'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/content/file/')({
  validateSearch: contentSearchSchema,
  loaderDeps: ({ search }) => ({ page: search.page, q: search.q, docId: search.docId }),
  loader: ({ params, deps }) =>
    fetchRagFiles({
      projectId: parseInt(params.projectId, 10),
      currentPage: deps.page,
      searchText: deps.q,
      docId: deps.docId
    }),
  head: () => ({ meta: [{ title: 'Workspace Content - Snowvault' }] }),
  component: FilePage
})

function FilePage() {
  const { projectId } = Route.useParams()
  const { items, pageCount, documentCount } = Route.useLoaderData()
  const { page, q, docId } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { projectTitle, projectTo } = useProjectBreadcrumb()

  useEffect(() => {
    if (items.length === 0 && page > 1) {
      void navigate({ search: { page: 1, q } })
    }
  }, [items.length, page, q, navigate])

  return (
    <RagFilePage
      breadcrumbs={[{ label: projectTitle, to: projectTo }, { label: 'Content' }, { label: 'Files' }]}
      items={items}
      projectId={parseInt(projectId, 10)}
      currentPage={page}
      pageCount={pageCount}
      documentCount={documentCount}
      searchText={q}
      onPageChange={(p) => void navigate({ search: { page: p, q } })}
      onSearchChange={(text) => void navigate({ search: { q: text, page: 1 } })}
      onClearDocId={docId !== undefined ? () => void navigate({ search: { page: 1, q: '' } }) : undefined}
    />
  )
}
